{
  "heading": "Modules",
  "newModule": "New Module",
  "emptyTitle": "No Modules Yet",
  "emptyMessage": "Create a Training Module to get started.",
  "retry": "Retry",
  "unknownCampus": "Unknown Campus",
  "unknownCategory": "Unknown Category"
}
